import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientSaveBusinessRelationshipMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { LegalClientSaveBusinessRelationshipParam } from 'api/types/params';

import {
  parseLegalClient,
  parseLegalClientBusinessRelationsParam,
} from './helpers';

export const useLegalClientSaveBusinessRelationship = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientSaveBusinessRelationshipMutation();

  const error = useError(apolloError);

  return {
    data: data?.legalClientSaveBusinessRelationship
      ? parseLegalClient(data.legalClientSaveBusinessRelationship)
      : undefined,
    loading,
    error,
    saveBusinessRelations: useCallback(
      async (id: string, params: LegalClientSaveBusinessRelationshipParam) => {
        const input = parseLegalClientBusinessRelationsParam(params);
        const res = await handle({
          variables: {
            id,
            input,
          },
        });
        return res?.data?.legalClientSaveBusinessRelationship
          ? parseLegalClient(res.data.legalClientSaveBusinessRelationship)
          : undefined;
      },
      [handle]
    ),
  };
};
